import { getRgObjectsOfType as i, RgChildren as t, RG_TYPE as e } from "@project-rouge/rg-core";
import { isBaseBuildObject as s } from "../../queries/index2.js";
import { isMiscDoor as l } from "../../queries/index6.js";
const d = (o) => {
  const r = i(o, t.Building);
  return i(r.filter(s), e.Door).filter(l).length;
};
export {
  d as getBaseBuildMiscDoorsCount
};
//# sourceMappingURL=index7.js.map
